'use client';

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

/**
 * Decide whether a failed query should be retried.
 * Never retry client errors (4xx) — especially 429 (rate-limited),
 * 401/403 (auth). Only retry transient server/network errors.
 */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error && typeof error === 'object' && 'status' in error) {
    const status = (error as {
      status: number;
    }).status;
    // 4xx errors are not transient — don't retry
    if (status >= 400 && status < 500) return false;
  }
  // Retry server errors (5xx) and network failures up to 2 times
  return failureCount < 2;
}
export function QueryProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  if ($[0] !== children || $[1] !== queryClient) {
    t1 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[0] = children;
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 300000,
        gcTime: 600000,
        retry: shouldRetry
      }
    }
  });
}